import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene un resultado EMeT por ID del resultado.
 * @param {string|number} id - ID del resultado EMeT.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Datos del resultado EMeT.
 */
export const fetchEmetResultById = async (id, token) => {
	const response = await certifications.get(`/emet/results/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene un resultado EMeT por ID de la certificación.
 * @param {string|number} id - ID de la certificación.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Resultado de EMeT correspondiente a la certificación.
 */
export const fetchEmetResultByCertificationId = async (id, token) => {
	const response = await certifications.get(`/emet/result/certification/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene todos los resultados finalizados de EMeT.
 * @param {string} token - Token JWT para autenticación.
 * @returns {Promise<Object>} - Lista de resultados finalizados.
 */
export const fetchEmetResultFinish = async (token) => {
	const response = await certifications.get(`/emet/results/finish`, {
		headers: getHeaders(token)
	});
	return response.data;
};

export const fetchEmetScoreSheetByCertification = async (certificationId, sectionId = null, token) => {
	const response = await certifications.get(`/emet/score/sheet/certification/${certificationId}`, {
		headers: getHeaders(token),
		params: sectionId ? { section_id: sectionId } : {}
	});
	return response.data;
};

export const fetchEmetScoreStatisticsByCertification = async (certificationId,  token) => {
	const response = await certifications.get(`/emet/score/sheet/statistics/${certificationId}`, {
		headers: getHeaders(token)
	});
	return response.data;
};